export class RemoveItemFromTemplateError extends Error {
  constructor(message: string = 'Failed to remove item from inspection template') {
    super(message);
    this.name = 'RemoveItemFromTemplateError';
  }
}
